import React from 'react'
import { Box, Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import ShellLoading from '@e3dc-react/shell/Elements/Loading/Loading'

import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

const useStyles = makeStyles()(theme => ({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    gap: theme.spacing(2),
  },
  typography: {
    '@media (max-width: 650px)': {
      textAlign: 'center',
    },
  },
}))

/**
 * Loading screen for case when test is running
 */
const Loading: React.FC = () => {
  const { classes } = useStyles()
  const { t } = useCustomTranslation()

  return (
    <Box className={classes.container}>
      <Typography variant={'body1'} className={classes.typography}>
        {t('system-details.hardware-test.loading-text')}
      </Typography>
      <ShellLoading circularProgress={{ size: 79 }} />
      <Typography variant={'body2'} className={classes.typography}>
        {t('system-details.hardware-test.loading-description')}
      </Typography>
    </Box>
  )
}

export default Loading
